import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { ICheckPaymentRequest } from '../../../repositories/billing-payments/v3/check-payment';

export enum EYandexPaymentStatus {
  PENDING = 'pending',
  SUCCEEDED = 'succeeded',
  CANCELED = 'canceled',
}

export interface IYandexPaymentStatus {
  /** Статус платежа */
  status: EYandexPaymentStatus;
  /** Поясняющий текст */
  message?: string;
}

export interface IGetYandexPaymentStatusDependencies {
  logger: ILogger;
  httpApi: IHttpApi;
  parameters: ICheckPaymentRequest;
}
